<tpm-dialog-frame
  *ngIf="vm$ | async as vm"
  alt-theme
  class="create-municipality-dialog"
  data-cy="create-municipality-dialog"
  [footerDivider]="true"
  [header]="'CONFIGURATION_AREA.DIALOGS.CREATE_MUNICIPALITY.TITLE' | translate"
  [submitButtonLabel]="'CONFIGURATION_AREA.DIALOGS.CREATE_MUNICIPALITY.SUBMIT' | translate"
  [closeButtonLabel]="'APP.CANCEL' | translate"
  [submitDisabled]="vm.step === 'ags' ? agsForm.invalid || vm.agsLookupLoading : detailsForm.invalid || vm.creating"
  (submitted)="onSubmit(vm.step)"
>
  <form
    *ngIf="vm.step === 'ags'; else detailsStep"
    name="createMunicipalityAgsForm"
    class="create-municipality-dialog__form"
    [formGroup]="agsForm"
  >
    <section class="create-municipality-dialog__section">
      <h6 class="create-municipality-dialog__section-title body-sm">
        {{ "CONFIGURATION_AREA.DIALOGS.SETTINGS.EXPANSION_PANELS.AREA_INFORMATION.TITLE" | translate }}
      </h6>
      <tpm-input-field
        variant="kp"
        data-cy="create-municipality-ags"
        formControlName="ags"
        [maxlength]="agsLength"
        [label]="'CONFIGURATION_AREA.DIALOGS.SETTINGS.TABS.COMMUNE.AREA_INFORMATION.AGS' | translate"
        [placeholder]="'CONFIGURATION_AREA.DIALOGS.CREATE_MUNICIPALITY.PLACEHOLDER' | translate"
        [validationMessage]="'CONFIGURATION_AREA.DIALOGS.CREATE_MUNICIPALITY.VALIDATION.AGS' | translate"
      ></tpm-input-field>
      <tpm-notice
        *ngIf="vm.agsLookupError"
        variant="error"
        icon="ec_info_outline"
        data-cy="create-municipality-lookup-error"
      >
        {{ "CONFIGURATION_AREA.DIALOGS.CREATE_MUNICIPALITY.LOOKUP_ERROR." + vm.agsLookupError | translate }}
      </tpm-notice>
    </section>
  </form>

  <ng-template #detailsStep>
    <form name="createMunicipalityDetailsForm" class="create-municipality-dialog__form" [formGroup]="detailsForm">
      <section class="create-municipality-dialog__section">
        <h6 class="create-municipality-dialog__section-title body-sm">
          {{ "CONFIGURATION_AREA.DIALOGS.SETTINGS.EXPANSION_PANELS.AREA_INFORMATION.TITLE" | translate }}
        </h6>
        <tpm-input-field
          variant="kp"
          data-cy="create-municipality-ags-readonly"
          formControlName="ags"
          [label]="'CONFIGURATION_AREA.DIALOGS.SETTINGS.TABS.COMMUNE.AREA_INFORMATION.AGS' | translate"
        ></tpm-input-field>
        <tpm-input-field
          variant="kp"
          data-cy="create-municipality-name"
          formControlName="name"
          [label]="'CONFIGURATION_AREA.DIALOGS.CREATE_MUNICIPALITY.NAME' | translate"
          [placeholder]="'CONFIGURATION_AREA.DIALOGS.CREATE_MUNICIPALITY.PLACEHOLDER' | translate"
          [validationMessage]="'CONFIGURATION_AREA.DIALOGS.CREATE_MUNICIPALITY.VALIDATION.NAME' | translate"
        ></tpm-input-field>
        <tpm-input-field
          variant="kp"
          data-cy="create-municipality-region-id"
          formControlName="regionId"
          [label]="'CONFIGURATION_AREA.DIALOGS.SETTINGS.TABS.COMMUNE.AREA_INFORMATION.REGION_ID' | translate"
        ></tpm-input-field>
        <tpm-input-field
          variant="kp"
          data-cy="create-municipality-longitude"
          formControlName="longitude"
          [label]="'CONFIGURATION_AREA.DIALOGS.SETTINGS.TABS.COMMUNE.AREA_INFORMATION.LONGITUDE' | translate"
          [placeholder]="'CONFIGURATION_AREA.DIALOGS.CREATE_MUNICIPALITY.PLACEHOLDER' | translate"
          [validationMessage]="'CONFIGURATION_AREA.DIALOGS.CREATE_MUNICIPALITY.VALIDATION.LONGITUDE' | translate"
        ></tpm-input-field>
        <tpm-input-field
          variant="kp"
          data-cy="create-municipality-latitude"
          formControlName="latitude"
          [label]="'CONFIGURATION_AREA.DIALOGS.SETTINGS.TABS.COMMUNE.AREA_INFORMATION.LATITUDE' | translate"
          [placeholder]="'CONFIGURATION_AREA.DIALOGS.CREATE_MUNICIPALITY.PLACEHOLDER' | translate"
          [validationMessage]="'CONFIGURATION_AREA.DIALOGS.CREATE_MUNICIPALITY.VALIDATION.LATITUDE' | translate"
        ></tpm-input-field>
        <app-select-field
          data-cy="create-municipality-zoom"
          name="zoomLevel"
          formControlName="zoomLevel"
          [options]="zoomLevelOptions"
          [label]="'CONFIGURATION_AREA.DIALOGS.SETTINGS.TABS.COMMUNE.AREA_INFORMATION.ZOOM_LEVEL' | translate"
        ></app-select-field>
      </section>

      <section class="create-municipality-dialog__section">
        <h6 class="create-municipality-dialog__section-title body-sm">
          {{ "CONFIGURATION_AREA.DIALOGS.CREATE_MUNICIPALITY.CONTRACT_RELATIONSHIP" | translate }}
        </h6>
        <div class="create-municipality-dialog__divisions">
          <tpm-checkbox-field
            class="create-municipality-dialog__division"
            data-cy="create-municipality-electricity"
            formControlName="hasElectricityDivision"
            [label]="'CONFIGURATION_AREA.DIALOGS.CREATE_MUNICIPALITY.LEASE_CONCESSION.ELECTRICITY' | translate"
          ></tpm-checkbox-field>
          <tpm-checkbox-field
            class="create-municipality-dialog__division"
            data-cy="create-municipality-gas"
            formControlName="hasGasDivision"
            [label]="'CONFIGURATION_AREA.DIALOGS.CREATE_MUNICIPALITY.LEASE_CONCESSION.GAS' | translate"
          ></tpm-checkbox-field>
        </div>
      </section>
    </form>
  </ng-template>
</tpm-dialog-frame>
